import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenancePrintsRulesComponent } from "./maintenance-prints-rules.component";
import { CreateEditPrintsRulesComponent } from "./create-edit-prints-rules/create-edit-prints-rules.component";
import { ListPrintsRulesComponent } from "./list-prints-rules/list-prints-rules.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesPrintsRules: Routes = [
  {
    path: "",
    component: MaintenancePrintsRulesComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListPrintsRulesComponent,
      },
      {
        path: "creacion",
        component: CreateEditPrintsRulesComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: CreateEditPrintsRulesComponent,
        data: {
          operation: "edicion",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesPrintsRules)],
  exports: [RouterModule],
})
export class PrintsRulesRoutingModule {}
